import React, {useState} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import {Card, CardBody, CardHeader, Col, Container, Row,} from 'reactstrap';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import {API_URL} from "constants/index.js";
import notify from '@utils/notify';

const filenameFromDisposition = (disposition, fallback) => {
    if (!disposition) return fallback;

    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match) return decodeURIComponent(utf8Match[1].trim());

    const match = disposition.match(/filename="?([^";]+)"?/i);
    return match ? match[1].trim() : fallback;
}

export default function CsvReports() {
    const [disableButtons, setDisableButtons] = useState(false);

    const downloadCsv = async (path, fallbackName) => {
        setDisableButtons(true);
        try {
            const token = Cookies.get('grs_token');
            const response = await axios.get(`${API_URL}/report/${path}`, {
                headers: {Authorization: `Bearer ${token}`},
                responseType: 'blob',
            });

            const fileName = filenameFromDisposition(
                response.headers['content-disposition'],
                fallbackName
            );

            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download CSV report error :: ', error);
            notify.warning('Something went wrong please try again later!');
        } finally {
            setDisableButtons(false);
        }
    };

    return (
        <>
            <CardsHeader name="Downloads!" parentName="CSV Reports" currentName="List"/>
            <Container className="mt--5 admin-main-body d-flex flex-wrap " fluid>
                <Col lg={6} sm="12">
                    <Card className={'reports-card-height'}>
                        <CardHeader>
                            <h2 className="title">Vehicles</h2>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <h4>
                                        Unsold vehicles
                                    </h4>
                                </Col>
                                <Col>
                                    <ButtonContainer disabled={disableButtons} onClick={() => {
                                        !disableButtons && downloadCsv('vehicles/unsold', 'vehicles.csv')
                                    }}>Download</ButtonContainer>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg={6} sm="12">
                    <Card className={'reports-card-height'}>
                        <CardHeader>
                            <h2 className="title">Deals</h2>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <h4>
                                        Delivered deals
                                    </h4>
                                </Col>
                                <Col>
                                    <ButtonContainer disabled={disableButtons} onClick={() => {
                                        !disableButtons && downloadCsv('deals/delivered', 'deals.csv')
                                    }}>Download</ButtonContainer>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <h4>
                                        Deal Payments (current month)
                                    </h4>
                                </Col>
                                <Col>
                                    <ButtonContainer disabled={disableButtons} onClick={() => {
                                        !disableButtons && downloadCsv('customer/payments', 'payments.csv')
                                    }}>Download</ButtonContainer>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Container>
        </>
    )
}
